module.exports = __webpack_public_path__ + "img/modificacion-y-transformacion-de-prendas.51120431.jpg";